module.exports = __webpack_public_path__ + "img/dashboard_bg.014ef45a.png";